export default __webpack_public_path__ + "static/media/expandPrimary.e301f506.svg";